
import { Component, ViewEncapsulation } from '@angular/core';
import { MDDialogModule, MDIconComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-reschedule-late-dialog',
	standalone: true,
	imports: [MDDialogModule, MDIconComponent],
	templateUrl: './reschedule-late-dialog.component.html',
	styleUrl: './reschedule-late-dialog.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class RescheduleLateDialogComponent {}
